<template>
  <div>
    <el-container class="px-3 mt-4">
      <search @onSearch="onSearch" />
    </el-container>
    <el-table
      :data="sales.rows"
      style="width: 100%"
      stripe
      :default-sort="{ prop: 'UploadTime', order: 'descending' }"
    >
      <el-table-column prop="mvm.AssetNo" label="機台編號" width="80" fixed />

      <el-table-column prop="GateNo" label="倉道" width="80" />
      <el-table-column prop="UploadTime" label="交易時間" width="180" sortable>
        <template slot-scope="scope">
          {{ scope.row.UploadTime | moment("YYYY/MM/DD, HH:mm") }}
        </template>
      </el-table-column>
      <el-table-column prop="ProductName" label="品名" />
      <el-table-column prop="PayAmt" label="金額" width="80" sortable />

      <el-table-column prop="invoice.Front" label="發票號碼">
        <template v-if="scope.row.invoice" slot-scope="scope">
          <el-popover
            placement="top-start"
            :title="scope.row.invoice.detail.invoiceType | invoiceFilter"
            width="200"
            trigger="hover"
          >
            <div slot="reference">
              <el-tag
                :type="
                  scope.row.invoice.detail.invoiceType | invoiceFilterClass
                "
              >
                {{ scope.row.invoice.Front }}{{ scope.row.invoice.Number }}
              </el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="CardNo" label="卡號" />
    </el-table>
  </div>
</template>
<script>
import { searchSales, getSales } from '@/api/transaction'
import { getEasycards } from '@/api/easycard'
import search from './components/search.vue'
const methods = {
  async onSearch(condition) {
    this.condition = condition
    try {
      this.sales = await getEasycards(this.condition, {})
    } catch (error) {}
  }
}
export default {
  components: { search },
  data() {
    return {
      condition: {},
      sales: {
        rows: []
      }
    }
  },
  methods
}
</script>
